module.exports = __webpack_public_path__ + "assets/img/returnBtn-b8c4f368.png";